module.exports = __webpack_public_path__ + "static/media/window-frame-open.fb6eb425.svg";